import {
  faGear,
  faOctagonXmark,
  faPause,
  faPlay,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HeaderToolbar = ({
  settingsClick,
  hideClick,
  textHidden,
  pauseClick,
  isApplicationPaused,
  appState,
  stopTextGeneration,
}) => {
  return (
    <div className="speakingSectionHeaderWrapper">
      <button
        className="speakingSectionSettingsButton"
        onClick={pauseClick}
        disabled={appState !== "waitingForUserAudio"}
      >
        <FontAwesomeIcon icon={isApplicationPaused ? faPlay : faPause} />
      </button>
      <button
        className="speakingSectionSettingsButton"
        title="Abort the current text generation"
        onClick={stopTextGeneration}
        disabled={appState !== "gettingSystemResponse"}
      >
        <FontAwesomeIcon icon={faOctagonXmark} />
      </button>
      <button
        className="speakingSectionSettingsButton"
        onClick={settingsClick}
        disabled={appState === "recording"}
      >
        <FontAwesomeIcon icon={faGear} />
      </button>
      <button
        className={
          textHidden
            ? "speakingSectionSettingsButtonWide"
            : "speakingSectionSettingsButtonWidedisabled"
        }
        onClick={hideClick}
      >
        {textHidden ? "Unhide text" : "Hide text"}
      </button>
    </div>
  );
};

export default HeaderToolbar;
